// PetShop.js — NeevPet shop: buy accessories, food, toys, themes & boosts with NeevCoins
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { showToast, playSound } from '../../utils/appUtils';

// ─── ALL SHOP ITEMS ────────────────────────────────────────
export const SHOP_ITEMS = {
  // ── SNACKS ──────────────────────────────────────────────
  apple:      { id:'apple',      cat:'snack', emoji:'🍎', name:'Apple',        desc:'Quick snack! +20 Hunger',     cost:5,  effect:{hunger:20} },
  samosa:     { id:'samosa',     cat:'snack', emoji:'🥟', name:'Samosa',        desc:'Desi treat! +35 Hunger',      cost:10, effect:{hunger:35} },
  pizza:      { id:'pizza',      cat:'snack', emoji:'🍕', name:'Pizza',         desc:'Cheesy goodness! +55 Hunger', cost:18, effect:{hunger:55} },
  icecream:   { id:'icecream',   cat:'snack', emoji:'🍦', name:'Ice Cream',     desc:'Cool & sweet! +45 Hunger',    cost:14, effect:{hunger:45} },
  cake:       { id:'cake',       cat:'snack', emoji:'🎂', name:'Celebration Cake',desc:'Party time! +75 Hunger',   cost:28, effect:{hunger:75} },
  starfruit:  { id:'starfruit',  cat:'snack', emoji:'⭐', name:'Star Fruit',    desc:'FULL hunger + glow!',         cost:45, effect:{hunger:100,happiness:20} },

  // ── ACCESSORIES ─────────────────────────────────────────
  tophat:     { id:'tophat',     cat:'style', emoji:'🎩', name:'Top Hat',       desc:'Classic & distinguished',      cost:30, slot:'hat',  owned:false },
  flowerhat:  { id:'flowerhat',  cat:'style', emoji:'🌸', name:'Flower Crown',  desc:'Fresh & adorable',             cost:22, slot:'hat',  owned:false },
  gradcap:    { id:'gradcap',    cat:'style', emoji:'🎓', name:'Grad Cap',      desc:'Scholar mode activated!',      cost:35, slot:'hat',  owned:false },
  partyhat:   { id:'partyhat',   cat:'style', emoji:'🎉', name:'Party Hat',     desc:'Always celebrating!',          cost:18, slot:'hat',  owned:false },
  cowboyhat:  { id:'cowboyhat',  cat:'style', emoji:'🤠', name:'Cowboy Hat',    desc:'Yeehaw partner!',              cost:28, slot:'hat',  owned:false },
  sunglasses: { id:'sunglasses', cat:'style', emoji:'🕶️', name:'Cool Shades',  desc:'Too cool for school',          cost:20, slot:'face', owned:false },
  monocle:    { id:'monocle',    cat:'style', emoji:'🧐', name:'Monocle',       desc:'Very distinguished indeed!',   cost:25, slot:'face', owned:false },
  clownhair:  { id:'clownhair',  cat:'style', emoji:'🤡', name:'Rainbow Hair',  desc:'Maximum silliness!',           cost:32, slot:'hat',  owned:false },

  // ── TOYS ────────────────────────────────────────────────
  ball:       { id:'ball',       cat:'toy',   emoji:'🎾', name:'Tennis Ball',   desc:'+15 Happiness. Pet chases it!',cost:10, effect:{happiness:15}, anim:'bounce' },
  frisbee:    { id:'frisbee',    cat:'toy',   emoji:'🥏', name:'Frisbee',       desc:'+20 Happiness. Pet spins!',    cost:14, effect:{happiness:20}, anim:'spin'   },
  musicbox:   { id:'musicbox',   cat:'toy',   emoji:'🎵', name:'Music Box',     desc:'+25 Happy. Pet dances!',       cost:20, effect:{happiness:25}, anim:'wave'   },
  magicbook:  { id:'magicbook',  cat:'toy',   emoji:'📖', name:'Magic Book',    desc:'+20 Happy & +10 XP',           cost:22, effect:{happiness:20,xp:10}, anim:'look' },
  kite:       { id:'kite',       cat:'toy',   emoji:'🪁', name:'Flying Kite',   desc:'+30 Happy. Pet floats high!',  cost:30, effect:{happiness:30}, anim:'bounce' },

  // ── WORLD THEMES ────────────────────────────────────────
  ocean:      { id:'ocean',      cat:'theme', emoji:'🌊', name:'Ocean World',   desc:'Underwater paradise',           cost:55, theme:'ocean'  },
  space:      { id:'space',      cat:'theme', emoji:'🚀', name:'Space Station', desc:'Among the stars!',              cost:65, theme:'space'  },
  sakura:     { id:'sakura',     cat:'theme', emoji:'🌸', name:'Sakura Garden', desc:'Cherry blossom paradise',       cost:50, theme:'sakura' },
  desert:     { id:'desert',     cat:'theme', emoji:'🏜️', name:'Desert Oasis', desc:'Mystical desert sands',         cost:45, theme:'desert' },
  candy:      { id:'candy',      cat:'theme', emoji:'🍭', name:'Candy Land',    desc:'Sweet sugary world!',           cost:60, theme:'candy'  },

  // ── BOOSTS ──────────────────────────────────────────────
  xpboost:    { id:'xpboost',    cat:'boost', emoji:'⚡', name:'XP Boost x2',   desc:'2× XP on your next quiz!',     cost:30, boost:'xp2',    duration:'1 quiz' },
  shield:     { id:'shield',     cat:'boost', emoji:'🛡️', name:'Streak Shield', desc:'Protect your streak once',     cost:40, boost:'shield', duration:'1 use'  },
  luckycharm: { id:'luckycharm', cat:'boost', emoji:'🍀', name:'Lucky Charm',   desc:'+50% coins on next quiz',       cost:25, boost:'coins',  duration:'1 quiz' },
  magnet:     { id:'magnet',     cat:'boost', emoji:'🧲', name:'Coin Magnet',   desc:'2× coins for 24 hours',        cost:35, boost:'magnet', duration:'24 hrs' },
};

const CATS = [
  { id:'snack', label:'🍎 Snacks',    desc:'Feed your pet to keep it healthy' },
  { id:'style', label:'👒 Style',     desc:'Accessories that appear ON your pet' },
  { id:'toy',   label:'🎮 Toys',      desc:'Play with your pet & boost happiness' },
  { id:'theme', label:'🌍 Themes',    desc:'Change your pet\'s world' },
  { id:'boost', label:'⚡ Boosts',    desc:'Power-ups for your next quiz' },
];

// ─── STORAGE HELPERS ──────────────────────────────────────
export function getOwned()    { try { return JSON.parse(localStorage.getItem('ns_pet_owned')||'[]'); } catch { return []; } }
export function getEquipped() { try { return JSON.parse(localStorage.getItem('ns_pet_equipped')||'{}'); } catch { return {}; } }
export function getActiveTheme() { return localStorage.getItem('ns_pet_theme') || 'default'; }
export function getActiveBoosts() { try { return JSON.parse(localStorage.getItem('ns_pet_boosts')||'{}'); } catch { return {}; } }

function saveOwned(o)    { localStorage.setItem('ns_pet_owned', JSON.stringify(o)); }
function saveEquipped(e) { localStorage.setItem('ns_pet_equipped', JSON.stringify(e)); }
function saveTheme(t)    { localStorage.setItem('ns_pet_theme', t); }
function saveBoosts(b)   { localStorage.setItem('ns_pet_boosts', JSON.stringify(b)); }

// ─── ACCESSORY OVERLAY ────────────────────────────────────
// Renders on top of the pet character (no SVG modification needed)
export function PetAccessories({ equipped, stageLevel, size=160 }) {
  const hat  = equipped?.hat  ? SHOP_ITEMS[equipped.hat]  : null;
  const face = equipped?.face ? SHOP_ITEMS[equipped.face] : null;
  const sz = size / 160;

  return (
    <div style={{ position:'absolute', inset:0, pointerEvents:'none', zIndex:15 }}>
      {/* HAT — sits above the head */}
      {hat && (
        <motion.div initial={{ scale:0 }} animate={{ scale:1 }} transition={{ type:'spring', stiffness:400, damping:18 }}
          style={{ position:'absolute',
            top: stageLevel>=3 ? `${-2*sz}%` : `${4*sz}%`,
            left:'50%', transform:'translateX(-50%)',
            fontSize: Math.round(36*sz),
            filter:'drop-shadow(0 2px 6px rgba(0,0,0,0.3))',
            lineHeight:1 }}>
          {hat.emoji}
        </motion.div>
      )}
      {/* FACE accessory — over the eyes area */}
      {face && (
        <motion.div initial={{ scale:0 }} animate={{ scale:1 }} transition={{ type:'spring', stiffness:400, damping:18 }}
          style={{ position:'absolute',
            top:'50%', left:'50%',
            transform:'translate(-50%,-50%)',
            fontSize: Math.round(28*sz),
            lineHeight:1 }}>
          {face.emoji}
        </motion.div>
      )}
    </div>
  );
}

// ─── MAIN SHOP COMPONENT ──────────────────────────────────
export default function PetShop({ coins, onCoinsEarned, onXPEarned, onHungerChange, onHappinessChange, onToy, onThemeChange, petName }) {
  const [cat, setCat] = useState('snack');
  const [owned, setOwned] = useState(getOwned);
  const [equipped, setEquipped] = useState(getEquipped);
  const [activeTheme, setActiveTheme] = useState(getActiveTheme);
  const [boosts, setBoosts] = useState(getActiveBoosts);
  const [buying, setBuying] = useState(null);
  const [justBought, setJustBought] = useState(null);

  const catItems = Object.values(SHOP_ITEMS).filter(i => i.cat === cat);

  const buy = (item) => {
    if ((coins||0) < item.cost) {
      showToast(`Need ${item.cost} 🪙 — only have ${coins||0}`, 'error');
      return;
    }
    setBuying(item.id);
    playSound('pet_buy');
    setTimeout(() => {
      // Deduct coins
      onCoinsEarned && onCoinsEarned(-item.cost);

      if (item.cat === 'snack') {
        playSound('pet_eat');
        // Apply immediately
        if (item.effect?.hunger)    onHungerChange    && onHungerChange(item.effect.hunger);
        if (item.effect?.happiness) onHappinessChange && onHappinessChange(item.effect.happiness);
        showToast(`${petName} loved the ${item.name}! 😋`, 'success');
      }
      else if (item.cat === 'toy') {
        playSound('pet_play');
        if (item.effect?.happiness) onHappinessChange && onHappinessChange(item.effect.happiness);
        if (item.effect?.xp)        onXPEarned        && onXPEarned(item.effect.xp);
        onToy && onToy(item.anim);
        showToast(`${petName} is playing with ${item.name}! 🎉`, 'success');
      }
      else if (item.cat === 'style') {
        if (!owned.includes(item.id)) {
          const o = [...owned, item.id];
          setOwned(o); saveOwned(o);
        }
        // Auto-equip
        const e = { ...equipped, [item.slot]: item.id };
        setEquipped(e); saveEquipped(e);
        showToast(`${item.name} equipped on ${petName}! 👒`, 'success');
      }
      else if (item.cat === 'theme') {
        setActiveTheme(item.theme); saveTheme(item.theme);
        onThemeChange && onThemeChange(item.theme);
        showToast(`World changed to ${item.name}! 🌍`, 'success');
      }
      else if (item.cat === 'boost') {
        const b = { ...boosts, [item.boost]: true };
        setBoosts(b); saveBoosts(b);
        showToast(`${item.name} activated! ${item.emoji}`, 'success');
      }

      setJustBought(item.id);
      setTimeout(() => { setJustBought(null); setBuying(null); }, 1200);
    }, 300);
  };

  const unequip = (slot) => {
    const e = { ...equipped };
    delete e[slot];
    setEquipped(e); saveEquipped(e);
    showToast('Accessory removed', 'info');
  };

  return (
    <div style={{ fontFamily:"'Nunito',sans-serif" }}>
      {/* Coins bar */}
      <div style={{ background:'linear-gradient(135deg,#FFD600,#FF9500)', padding:'12px 16px',
        display:'flex', alignItems:'center', gap:10 }}>
        <span style={{ fontSize:28 }}>🪙</span>
        <div>
          <p style={{ margin:0, fontSize:20, fontWeight:900, color:'white' }}>{coins||0} NeevCoins</p>
          <p style={{ margin:0, fontSize:11, color:'rgba(255,255,255,0.8)', fontWeight:700 }}>Earn more by answering quiz questions!</p>
        </div>
      </div>

      {/* Active boosts banner */}
      {Object.keys(boosts).length > 0 && (
        <div style={{ background:'#E8FAF0', padding:'8px 16px', display:'flex', gap:8, flexWrap:'wrap' }}>
          {Object.keys(boosts).map(b => {
            const item = Object.values(SHOP_ITEMS).find(i => i.boost === b);
            return item ? (
              <span key={b} style={{ background:'#00C851', color:'white', borderRadius:10, padding:'3px 10px', fontSize:11, fontWeight:900 }}>
                {item.emoji} {item.name} ACTIVE
              </span>
            ) : null;
          })}
        </div>
      )}

      {/* Equipped accessories */}
      {(equipped.hat || equipped.face) && (
        <div style={{ padding:'10px 16px', background:'#FFF8F0', borderBottom:'1px solid #F0F0F0' }}>
          <p style={{ margin:'0 0 8px', fontSize:11, fontWeight:900, color:'#888' }}>👒 CURRENTLY WEARING</p>
          <div style={{ display:'flex', gap:8 }}>
            {['hat','face'].map(slot => equipped[slot] && (
              <div key={slot} style={{ display:'flex', alignItems:'center', gap:6, background:'white', borderRadius:12,
                padding:'6px 12px', border:'1.5px solid #FFD600', cursor:'pointer' }}
                onClick={() => unequip(slot)}>
                <span style={{ fontSize:20 }}>{SHOP_ITEMS[equipped[slot]]?.emoji}</span>
                <span style={{ fontSize:11, fontWeight:900, color:'#666' }}>{SHOP_ITEMS[equipped[slot]]?.name}</span>
                <span style={{ fontSize:10, color:'#AAA', fontWeight:700 }}>✕</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Category tabs */}
      <div style={{ display:'flex', gap:0, overflowX:'auto', borderBottom:'2px solid #F0F0F0',
        scrollbarWidth:'none', background:'white' }}>
        {CATS.map(c => (
          <button key={c.id} onClick={() => setCat(c.id)}
            style={{ flexShrink:0, padding:'10px 14px', border:'none', cursor:'pointer', background:'none',
              fontFamily:"'Nunito',sans-serif", fontSize:12, fontWeight:900,
              color: cat===c.id ? '#FF9500' : '#AAA',
              borderBottom:`3px solid ${cat===c.id ? '#FF9500' : 'transparent'}`,
              transition:'all 0.15s' }}>
            {c.label}
          </button>
        ))}
      </div>

      {/* Category description */}
      <div style={{ padding:'8px 16px', background:'#FAFAFA' }}>
        <p style={{ margin:0, fontSize:12, fontWeight:700, color:'#888' }}>
          {CATS.find(c => c.id === cat)?.desc}
        </p>
      </div>

      {/* Items grid */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, padding:'12px 16px' }}>
        {catItems.map(item => {
          const canAfford = (coins||0) >= item.cost;
          const isEquipped = item.slot && equipped[item.slot] === item.id;
          const isTheme = item.theme && activeTheme === item.theme;
          const isOwned = owned.includes(item.id);
          const isBuying = buying === item.id;
          const wasBought = justBought === item.id;

          return (
            <motion.div key={item.id}
              whileTap={canAfford ? { scale:0.94 } : {}}
              onClick={() => canAfford && !isBuying ? buy(item) : null}
              style={{ background: wasBought ? '#E8FAF0' : isEquipped||isTheme ? '#FFF8E1' : 'white',
                borderRadius:18, padding:'14px 12px', textAlign:'center', cursor:canAfford?'pointer':'not-allowed',
                border:`2px solid ${wasBought?'#00C851':isEquipped||isTheme?'#FFD600':canAfford?'#F0F0F0':'#F5F5F5'}`,
                opacity: canAfford ? 1 : 0.55,
                boxShadow: isEquipped||isTheme ? '0 4px 16px rgba(255,214,0,0.3)' : '0 2px 8px rgba(0,0,0,0.05)',
                transition:'all 0.2s', position:'relative' }}>

              {/* Item emoji */}
              <motion.div animate={isBuying ? { scale:[1,1.4,1], rotate:[0,10,-10,0] } : {}}
                transition={{ duration:0.5 }}
                style={{ fontSize:42, lineHeight:1, marginBottom:8 }}>
                {item.emoji}
              </motion.div>

              {/* Name */}
              <p style={{ margin:'0 0 3px', fontSize:12, fontWeight:900, color:'#1A1A2E', lineHeight:1.2 }}>{item.name}</p>

              {/* Desc */}
              <p style={{ margin:'0 0 10px', fontSize:10, color:'#888', fontWeight:700, lineHeight:1.4 }}>{item.desc}</p>

              {/* Price / status */}
              {isEquipped ? (
                <div style={{ background:'#FFD600', borderRadius:10, padding:'4px 10px',
                  fontSize:10, fontWeight:900, color:'#7A5000' }}>✓ WEARING</div>
              ) : isTheme ? (
                <div style={{ background:'#FFD600', borderRadius:10, padding:'4px 10px',
                  fontSize:10, fontWeight:900, color:'#7A5000' }}>✓ ACTIVE</div>
              ) : wasBought ? (
                <motion.div initial={{ scale:0 }} animate={{ scale:1 }}
                  style={{ background:'#00C851', borderRadius:10, padding:'4px 10px',
                    fontSize:10, fontWeight:900, color:'white' }}>✓ Done!</motion.div>
              ) : (
                <div style={{ background:canAfford?'linear-gradient(135deg,#FF9500,#FFD600)':'#E0E0E0',
                  borderRadius:10, padding:'5px 12px', display:'inline-flex', alignItems:'center', gap:4,
                  fontSize:12, fontWeight:900, color:canAfford?'white':'#AAA' }}>
                  🪙 {item.cost}
                </div>
              )}

              {/* "Can't afford" overlay */}
              {!canAfford && (
                <div style={{ position:'absolute', top:8, right:8, background:'#FF2D55', borderRadius:8,
                  padding:'1px 6px', fontSize:9, fontWeight:900, color:'white' }}>
                  Need {item.cost - (coins||0)} more
                </div>
              )}

              {/* Duration badge for boosts */}
              {item.duration && (
                <div style={{ position:'absolute', top:8, left:8, background:'#E3F2FD',
                  borderRadius:8, padding:'1px 6px', fontSize:9, fontWeight:800, color:'#1565C0' }}>
                  {item.duration}
                </div>
              )}
            </motion.div>
          );
        })}
      </div>

      {/* How to earn coins tip */}
      <div style={{ margin:'4px 16px 24px', background:'#F0FFF4', borderRadius:14,
        padding:'12px 14px', border:'1px solid #C8E6C9' }}>
        <p style={{ margin:0, fontSize:12, fontWeight:700, color:'#388E3C' }}>
          💡 <strong>How to earn more coins:</strong> Answer quiz questions, complete daily challenges, and build your streak!
        </p>
      </div>
    </div>
  );
}
